var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"flat":"","color":"primary","dark":""}},on),[_c('v-icon',[_vm._v("language")])],1)]}}])},[_vm._v(" "),_c('v-list',_vm._l((_vm.locales),function(lcl){return _c('v-list-tile',{key:lcl.key,on:{"click":function($event){return _vm.setLocale(lcl.key)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(lcl.display))])],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffda2480","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocalePicker.vue
// module id = null
// module chunks = 